import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";

import HomePage from "@/pages/HomePage";
import LiveInCarePage from "@/pages/LiveInCarePage";
import OvernightCarePage from "@/pages/OvernightCarePage";
import VisitingCarePage from "@/pages/VisitingCarePage";
import AboutPage from "@/pages/AboutPage";
import CareersPage from "@/pages/CareersPage";
import ContactPage from "@/pages/ContactPage";
import AreaPage from "@/pages/AreaPage";
import LocationsPage from "@/pages/LocationsPage";
import PolicyPage from "@/pages/PolicyPage";

function App() {
  // Global click listener — fires a GTM phone_click event whenever any
  // tel: link is tapped, regardless of which page or component it lives in.
  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest && e.target.closest("a[href^='tel:']");
      if (!a) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "phone_click",
        phone_number: a.getAttribute("href").replace("tel:", ""),
        click_location: a.getAttribute("data-testid") || "unknown",
        page_path: window.location.pathname,
      });
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/live-in-care" element={<LiveInCarePage />} />
          <Route path="/overnight-care" element={<OvernightCarePage />} />
          <Route path="/visiting-care" element={<VisitingCarePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/locations" element={<LocationsPage />} />
          <Route path="/live-in-care/:slug" element={<AreaPage />} />
          <Route path="/privacy" element={<PolicyPage />} />
          <Route path="/cookies" element={<PolicyPage />} />
          <Route path="/safeguarding" element={<PolicyPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
